import { produce } from 'immer';
import {
  CREATE_SCHEDULE_ACTION,
  CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL,
  CAMPAIGN_FORM_UPDATE_TEMPLATE_DETAIL,
  CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL,
  CAMPAIGN_FORM_ERROR,
  UPDATE_CURRENT_FORM_STEP,
  UPDATE_FORM_VALIDATION,
  CLEAR_CAMPAIGN_FORM,
  UPDATE_FORM_SUBMISSION_STATUS,
  TEST_EMAIL_ACTION,
  DELETE_CAMPAIGN,
  GET_ALL_CAMPAIGNS
} from '../actions/createScheduleActionTypes';
import {
  DEFAULT_CAMPAIGN_FORM_STATE,
  DEFAULT_TEST_EMAIL_DETAILS,
  Frequency,
} from '../enums/schedulingConstant';

const intialState = {
  create: {
    status: '',
    payload: '',
    message: '',
  },
  campaignFormState: {
    segmentDetails: {
      segmentType: '',
      segmentName: '',
      segmentId: '',
    },
    templateDetails: {
      messageTemplateName: '',
      fromAddress: null,
    },
    campaignDetails: {
      frequency: Frequency.ONCE,
      startTime: '',
      endTime: '',
      timeZone: '',
      sendImmediate: false,
    },
    error: {},
    currentActiveStep: '',
    isValid: false,
    isSubmitSuccess: false,
  },
  testEmailDetails: {
    status: '',
    response: '',
  },
  createdCampaigns: {
    response: {},
    status: '',
  },
  deleteCampaign: {},
};
export default function campaign(state = intialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      case CREATE_SCHEDULE_ACTION: {
        draftState.create = action.payload ?? {};
        break;
      }
      case CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL: {
        draftState.campaignFormState.segmentDetails = {
          ...state.campaignFormState.segmentDetails,
          ...action.payload,
        };
        break;
      }
      case CAMPAIGN_FORM_UPDATE_TEMPLATE_DETAIL: {
        draftState.campaignFormState.templateDetails = {
          ...state.campaignFormState.templateDetails,
          ...action.payload,
        };
        break;
      }
      case CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL: {
        draftState.campaignFormState.campaignDetails = {
          ...state.campaignFormState.campaignDetails,
          ...action.payload,
        };
        break;
      }
      case CAMPAIGN_FORM_ERROR: {
        draftState.campaignFormState.error = {
          ...state.campaignFormState.error,
          ...action.payload,
        };
        break;
      }
      case UPDATE_CURRENT_FORM_STEP: {
        draftState.campaignFormState.currentActiveStep = action.payload;
        break;
      }
      case UPDATE_FORM_VALIDATION: {
        draftState.campaignFormState.isValid = action.payload ?? false;
        break;
      }
      case CLEAR_CAMPAIGN_FORM: {
        draftState.campaignFormState = DEFAULT_CAMPAIGN_FORM_STATE;
        draftState.testEmailDetails = DEFAULT_TEST_EMAIL_DETAILS;
        draftState.create = {
          status: '',
          payload: '',
          message: '',
        };
        break;
      }
      case UPDATE_FORM_SUBMISSION_STATUS: {
        draftState.campaignFormState.isSubmitSuccess = action.state ?? false;
        break;
      }
      case TEST_EMAIL_ACTION: {
        draftState.testEmailDetails = { ...state.testEmailDetails, ...action.payload } ?? false;
        break;
      }
      case GET_ALL_CAMPAIGNS: {
        draftState.createdCampaigns = action.payload ?? {};
        break;
      }
      case DELETE_CAMPAIGN: {
        draftState.deleteCampaign = action.payload ?? {};
        break;
      }
      default: {
        break;
      }
    }
  });
}
